import React, { useEffect } from 'react';

const GoogleMap = ({ apiKey, latitude, longitude, name }) => {
  useEffect(() => {
    const loadMapScript = () => {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=initMap`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    };

    window.initMap = () => {
      // Set default values for Dubai if latitude or longitude is 0 or empty or null
      const defaultLatitude = latitude || 25.276987;
      const defaultLongitude = longitude || 55.296249;

      const map = new window.google.maps.Map(document.getElementById('map'), {
        center: { lat: defaultLatitude, lng: defaultLongitude },
        zoom: 15,
      });

      const marker = new window.google.maps.Marker({
        position: { lat: defaultLatitude, lng: defaultLongitude },
        map: map,
        title: name || 'Dubai', // Set default name as 'Dubai'
      });

      const infoWindow = new window.google.maps.InfoWindow({
        content: `<h6>${name || 'Dubai'}</h6>`, // Set default name as 'Dubai'
      });

      // Add custom control to show name in the top left corner
      const nameControlDiv = document.createElement('div');
      const nameControl = new NameControl(nameControlDiv, name || 'Dubai');
      map.controls[window.google.maps.ControlPosition.TOP_RIGHT].push(nameControlDiv);

      // Show info window on marker click
      marker.addListener('click', () => {
        infoWindow.open(map, marker);
      });
    };

    // Custom control class
    function NameControl(controlDiv, name) {
      controlDiv.style.padding = '10px';
      controlDiv.style.margin = '10px'; // Add margin for white space
      controlDiv.style.backgroundColor = 'white';
      controlDiv.style.border = '2px solid #ccc';
      controlDiv.style.borderRadius = '5px'; // Add border radius for a rounded look
      const controlUI = document.createElement('div');
      controlUI.style.textAlign = 'center';
      controlUI.style.fontSize = '14px';
      controlUI.innerHTML = `<strong>${name}</strong>`;
      controlDiv.appendChild(controlUI);
    }

    loadMapScript();
  }, [apiKey, latitude, longitude, name]);

  return <div id="map" style={{ height: '400px', width: '100%' }}></div>;
};

export default GoogleMap;
